// frontend/src/pages/Profile/AddressBook.jsx
import React, { useState, useEffect } from 'react';
import { profileService } from '../components/services/profileServices';
import { useProfile } from '../contexts/ProfileContext';  
import './address-book.scss';

const AddressBook = () => {
    const { refreshProfile } = useProfile();
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        loadAddresses();
    }, []);

    const loadAddresses = async () => {
        setLoading(true);
        console.log('🔄 Ricarico indirizzi...');

        const result = await profileService.getAddresses();
        console.log('📦 Indirizzi caricati:', result);
        
        if (result.success) {
            setAddresses(result.addresses || []);
        }
        setLoading(false);
    };

    const handleSetDefault = async (addressId) => {
        console.log('📍 Imposto come predefinito:', addressId);
        
        try {
            const result = await profileService.setDefaultAddress(addressId);
            console.log('📦 Risultato:', result);
            
            if (result.success) {
                // ✅ FORZA IL RICARICO DEGLI INDIRIZZI
                await loadAddresses();
                
                // ✅ AGGIORNA IL PROFILO (se disponibile)
                if (refreshProfile) {
                    await refreshProfile();
                }
                
                // ✅ MOSTRA UN FEEDBACK VISIVO
                alert('✅ Indirizzo impostato come predefinito con successo!');
            } else {
                alert('❌ Errore: ' + (result.message || 'Impossibile impostare come predefinito'));
            }
        } catch (error) {
            console.error('❌ Errore handleSetDefault:', error);
            alert('❌ Errore durante l\'impostazione');
        }
    };

    const handleDelete = async (addressId) => {
        // ... controllo se è predefinito ...
        const result = await profileService.deleteAddress(addressId);
        if (result.success) {
            await loadAddresses();        // ✅ Ricarica gli indirizzi
            await refreshProfile();       // ✅ Aggiorna il profilo
        }
    };

    if (loading) {
        return <div className="loading">Caricamento indirizzi...</div>;
    }

    return (
        <div className="address-book">
            <div className="section-header">
                <h2>📍 Indirizzi di Spedizione</h2>
                <button className="btn-add" onClick={() => setShowForm(true)}>
                    + Aggiungi Indirizzo
                </button>
            </div>

            {addresses.length === 0 ? (
                <div className="empty-state">
                    <p>Nessun indirizzo salvato</p>
                    <button onClick={() => setShowForm(true)}>
                        Aggiungi il tuo primo indirizzo
                    </button>
                </div>
            ) : (
                <div className="addresses-grid">
                    {addresses.map(address => (
                        <div key={address.id} className={`address-card ${address.predefinito ? 'default' : ''}`}>
                            {address.predefinito && <span className="default-badge">⭐ Predefinito</span>}
                            <div className="address-type">
                                {profileService.getAddressType(address.tipo_indirizzo)?.icon} 
                                {profileService.getAddressType(address.tipo_indirizzo)?.label}
                            </div>
                            <p className="address-name">{address.nome} {address.cognome}</p>
                            {address.azienda && <p className="address-company">{address.azienda}</p>}
                            <p className="address-line">{address.indirizzo}</p>
                            <p className="address-city">{address.citta}, {address.provincia} {address.cap}</p>
                            <p className="address-country">{address.nazione}</p>
                            {address.telefono && <p className="address-phone">📞 {address.telefono}</p>}
                            
                            <div className="address-actions">
                                {!address.predefinito && (
                                    <button className="btn-set-default" onClick={() => handleSetDefault(address.id)}>
                                        ⭐ Imposta come predefinito
                                    </button>
                                )}
                                <button className="btn-delete" onClick={() => handleDelete(address.id)}>
                                    🗑️ Elimina
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Form per aggiungere/modificare indirizzo - versione semplificata */}
            {showForm && (
                <div className="modal-overlay" onClick={() => setShowForm(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <h3>📝 Nuovo Indirizzo</h3>
                        <form onSubmit={async (e) => {
                            e.preventDefault();
                            const formData = new FormData(e.target);
                            const addressData = {
                                nome: formData.get('nome'),
                                cognome: formData.get('cognome'),
                                azienda: formData.get('azienda') || '',
                                indirizzo: formData.get('indirizzo'),
                                citta: formData.get('citta'),
                                provincia: formData.get('provincia').toUpperCase(),
                                cap: formData.get('cap'),
                                telefono: formData.get('telefono'),
                                email: formData.get('email'),
                                tipo_indirizzo: 'spedizione',
                                predefinito: false  // ← NUOVO INDIRIZZO NON È PREDEFINITO
                            };
                            
                            const result = await profileService.createAddress(addressData);
                            if (result.success) {
                                setShowForm(false);
                                loadAddresses();
                                alert('✅ Indirizzo aggiunto con successo!');
                            } else {
                                alert('❌ Errore durante il salvataggio');
                            }
                        }}>
                            <div className="form-row">
                                <input name="nome" placeholder="Nome *" required />
                                <input name="cognome" placeholder="Cognome *" required />
                            </div>
                            
                            <input name="azienda" placeholder="Azienda (opzionale)" />
                            
                            <input name="indirizzo" placeholder="Via/Piazza *" required />
                            
                            <div className="form-row">
                                <input name="citta" placeholder="Città *" required />
                                <input name="provincia" placeholder="Provincia * (es. PE)" maxLength="2" required />
                                <input name="cap" placeholder="CAP * (5 cifre)" maxLength="5" required />
                            </div>
                            
                            <div className="form-row">
                                <input name="telefono" placeholder="Telefono *" required />
                                <input name="email" placeholder="Email *" type="email" required />
                            </div>
                            
                            <div className="form-actions">
                                <button type="button" onClick={() => setShowForm(false)}>Annulla</button>
                                <button type="submit">💾 Salva indirizzo</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddressBook;
